import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../interfaces/users.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'basic-data',
  standalone: false,
  templateUrl: './basic-data.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./basic-data.component.scss']
})
export class BasicDataComponent {
  @Input() user!: User | null;  
  registerForm: FormGroup;

  constructor(private fb: FormBuilder, private usersService: UsersService, private snackBar: MatSnackBar) {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      repwd: ['', [Validators.required]],
    }, { validators: this.passwordsMatchValidator });
  }

  passwordsMatchValidator(group: FormGroup): { [key: string]: boolean } | null {

    const password = group.get('password')?.value;
    const repassword = group.get('repwd')?.value;
    return password === repassword ? null : { passwordsMismatch: true };

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Check if the user input has changed
    if (changes['user'] && changes['user'].currentValue) {
      this.updateForm(changes['user'].currentValue);
    }
  }

  updateForm(user: User): void {
    // Update the form with the user data
    this.registerForm.patchValue({
      email: user.email || '',
      password: '', // Do not prefill the password for security reasons
      repwd: '', // Do not prefill the repeated password
    });
  }


  ngOnInit(): void {
    this.registerForm.get('repwd')?.valueChanges.subscribe(() => {
      const password = this.registerForm.get('password')?.value;
      const repassword = this.registerForm.get('repwd')?.value;
      if (password === repassword) {
        this.registerForm.get('repwd')?.setErrors(null);
      } else {
        this.registerForm.get('repwd')?.setErrors({ passwordsMismatch: true });
      }
    });
  }


  onSubmit(): void {
    if (this.registerForm.valid) {
      const { password } = this.registerForm.value;

      // Prepare the user data
      const user: User = { password, id: this.user?.id || 0 };

      // Call the UsersService to create the user
      this.usersService.updateCurrent(user).subscribe({
        next: (response) => {
          this.snackBar.open('Twoje hasło zostało zmienione', 'Zamknij', {
            duration: 9000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });
        },
        error: (err) => {
          let errorMessage = err.error?.detail || 'An error occurred';
         

          this.snackBar.open(errorMessage, 'Zamknij', {
            duration: 20000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });
        },
      });
    }
  }
}
